import PageScaffold from '../../components/PageScaffold';

import { useContext, useEffect, useState } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import AuthenticationContext from '../../contexts/auth/AuthenticationContext';
import { formatNumber } from '@leedpulse-monorepo/utils';
import FilesList from '../../components/files_page/FilesList';
import getAllFiles from '../../../domain/use_cases/users/getAllFiles';
import { IGlobalFile } from '@leedpulse-monorepo/interfaces';
import { TFileOwnerType } from '@leedpulse-monorepo/types';

export const FILES_PAGE_PATH = '/files';
export const FILES_PAGE_TITLE = 'Documents';

const FilesPage: React.FC = () => {
  const authContext = useContext(AuthenticationContext);

  const [items, setItems] = useState<IGlobalFile[]>([]);
  const [page, setPage] = useState<number>(1);
  const [total, setTotal] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [hitsPerPage, setHitsPerPage] = useState<number>(20);
  const [ownerType, setOwnerType] = useState<TFileOwnerType | 'all'>('all');

  async function fetchFiles(pageToFetch = 1, newHitsPerPage = hitsPerPage, newOwnerType = ownerType) {
    setIsLoading(true);
    try {
      const { items, totalCount } = await getAllFiles(newHitsPerPage, pageToFetch, authContext.authentication, newOwnerType);
      setItems(items);
      setTotal(totalCount);
      setPage(pageToFetch);
      setHitsPerPage(newHitsPerPage);
      setOwnerType(newOwnerType);
    } catch (err) {
      console.error('[Files] erreur :', err);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // Synchro avec un contexte qui fetche : l'etat local suit le resultat d'un
    // chargement declenche ici. Architecture Context + use case du repo.
    // eslint-disable-next-line react/set-state-in-effect
    fetchFiles(1);
  }, []);

  return (
    <PageScaffold
      title={FILES_PAGE_TITLE + ' (' + formatNumber(total) + ')'}
      subtitle="Tous les documents uploadés, utilisateurs et entreprises confondus"
      breadcrumbItems={[{ title: 'Documents' }]}
      controlsSettings={{
        searchLabel: '',
        onSearch: (_) => {return;},
        onSearchCancel: () => {return;},
        hideSearch: true,
        isLoading: false,
        actionButtons: [
          {
            label: 'Rafraîchir',
            type: 'primary',
            props: {
              icon: <ReloadOutlined />,
              onClick: () => fetchFiles(page),
            },
          },
        ],
      }}
    >
      <FilesList
        items={items}
        loading={isLoading}
        page={page}
        total={total}
        hitsPerPage={hitsPerPage}
        ownerType={ownerType}
        onOwnerTypeChange={(type) => fetchFiles(1, hitsPerPage, type)}
        onPaginationChange={(p, size) => fetchFiles(p, size)}
        onRefresh={() => fetchFiles(page)}
      />
    </PageScaffold>
  );
};

export default FilesPage;
